import smoothscroll from "smoothscroll-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import {createStore, applyMiddleware, compose} from "redux";
import { routerMiddleware } from 'connected-react-router';
import createRootReducer from './js/reducers';
import App from './App';
import * as serviceWorker from './serviceWorker';

import './index.css';

export const history = createBrowserHistory();



// Use the Redux DevTools compose enhancer when the browser extension is
// present, otherwise fall back to plain redux compose. Calling
// window.__REDUX_DEVTOOLS_EXTENSION__() unconditionally throws a TypeError on
// every browser WITHOUT the extension installed, which crashes the app before
// it mounts (blank page) — it only "worked" on dev machines that had the
// extension. This guard fixes that.
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const Store = createStore(
    createRootReducer(history),
    composeEnhancers(
        applyMiddleware(
            routerMiddleware(history)
        )
    )
);

ReactDOM.render(
    <Provider store={Store}>
        <App history={history} />
    </Provider>,
    document.getElementById('root')
);

smoothscroll.polyfill();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
